import { useState } from 'react';
import { Entity } from '../../../../../types/entity';
import { ReactComponent as XeroDisconnect } from '../../../../../assets/xero-disconnect.svg';
import XeroDisconnectConfirm from './XeroDisconnectConfirm';
import { SimpleAlert } from '@cimplico/components';
import { useUserContext } from '../../../../../providers/UserProvider';
import { useIsActiveSubscription } from '../../../../../hooks/use-is-active-subscription';
import { useIsFirmRole } from '../../../../../hooks/use-is-firm-role';

type XeroEntityDisconnectProps = {
    entity: Entity;
};

function XeroEntityDisconnect({ entity }: XeroEntityDisconnectProps): JSX.Element {
    const [disconnect, setDisconnect] = useState(false);
    const [error, setError] = useState<string | undefined>();
    const { isAdmin } = useIsFirmRole();
    const user = useUserContext();
    const activeSubscription = useIsActiveSubscription();

    const xeroReferWarning = user.xero?.xeroRefer && !isAdmin;

    return (
        <div>
            {xeroReferWarning && (
                <div className="my-4 max-w-[450px]">
                    <SimpleAlert
                        type="warn"
                        title="Your account has been flagged as a Xero app store referral. As you are NOT the firm admin, you will not be able to disconnect this Xero entity. To resolve this issue, please contact support."
                    />
                </div>
            )}
            {error && <SimpleAlert type="error" title={error} />}
            <XeroDisconnectConfirm
                entity={entity}
                onCancel={(): void => setDisconnect(false)}
                onClose={(): void => setDisconnect(false)}
                onError={setError}
                isOpen={disconnect}
            />
            <p className="text-gray-700">
                <span className="font-medium">Connected Xero Entity:</span> {entity.integrations.xero?.name}
            </p>

            {error && <p></p>}
            <button
                className="mt-4"
                onClick={(): void => {
                    setError(undefined);
                    setDisconnect(true);
                }}
                disabled={!activeSubscription || xeroReferWarning}
            >
                <XeroDisconnect />
            </button>
        </div>
    );
}
export default XeroEntityDisconnect;
